import { Injectable } from '@angular/core';
//import { Response } from '@angular/http';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';

import { IAirport, IOperation, IOperationListColumnResponse, OperationsListRequest, ReforecastRequest, IReforecastResponse, RegionalReviewRequest } from './airport-interfaces';
import { FacilitySearchRequest } from './facility-search-request';

import { HttpHelper } from '../shared/http-helper';
import { FileUpload } from 'primeng/primeng';

@Injectable()
export class AirportService {
    locId: string;
    scenarioId: number;
    //need to have this somewhere besides hardcoded in here
    //private _baseAirportUrl = `http://localhost:55706/api/airport`;
    private _baseAirportUrl = `api/airport`;

    constructor(private httpHelper: HttpHelper) { }

    getAirport(locId: string, scenarioId: number): Observable<IAirport> {

        this.locId = locId;
        this.scenarioId = scenarioId;
        //console.log("scenarioId: " + scenarioId);
        return this.httpHelper.get(`${this._baseAirportUrl}/${scenarioId}/${locId}`);
    }

    getAirportLocIds(scenarioId: number): Observable<string[]> {
        return this.httpHelper.get(`${this._baseAirportUrl}/locidlist/${scenarioId}`);
    }

    getAirportLocIdsByCriteria(request: FacilitySearchRequest): Observable<string[]> {
        let url: string = `${this._baseAirportUrl}/facilities/search?` +
            `baseScenarioId=${request.baseScenarioId}` +
            `&locId=${request.locId}` +
            `&region=${request.region}` +
            `&state=${request.state}` +
            `&hubSize=${request.hubSize}` +
            `&level=${request.level}` +
            `&type=${request.type}` +
            `&allFaaTowers=${request.allFaaTowers}` +
            `&allFaaAndContractTowers=${request.allFaaContractTowers}` +
            `&oep35=${request.oep35}` +
            `&centerId=${request.centerId}` +
            `&relieverFacility=${request.relieverFacility}` +
            `&relieverLocId=${request.relieverLocId}` +
            `&approachControlId=${request.approachControlId}` +
            `&searchOption=${request.searchOption}` +
            `&selectVariable=${request.selectVariable}` +
            `&growthStartYear=${request.growthStartYear}` +
            `&growthEndYear=${request.growthEndYear}` +
            `&growthOperator=${request.growthOperator}` +
            `&growthPercentage=${request.growthPercentage}` +
            `&growthExcludeChanges=${request.growthExcludeChanges}` +
            `&varValueYear=${request.varValueYear}` +
            `&varValueOperator=${request.varValueOperator}` +
            `&varValue=${request.varValue}`;
        return this.httpHelper.get(url);
    }

    getAirportCenterIds(baseScenarioId: number): Observable<string[]> {
        return this.httpHelper.get(`${this._baseAirportUrl}/centerids/${baseScenarioId}`);
    }

    getRelieverLocIds(scenarioId: number): Observable<string[]> {
        return this.httpHelper.get(`${this._baseAirportUrl}/relieverids/${scenarioId}`);
    }

    getApproachControlIds(scenarioId: number): Observable<string[]> {
        return this.httpHelper.get(`${this._baseAirportUrl}/approachcontrolids/${scenarioId}`);
    }

    getScenarioNotes(locId: string, scenarioId: number): Observable<string> {
        return this.httpHelper.get(`${this._baseAirportUrl}/scenarionotes/${scenarioId}/${locId}`);
    }
    getFacilityList(scenarioId: number): Observable<IAirport[]> {
        return this.httpHelper.get(`${this._baseAirportUrl}/facilitylist/${scenarioId}`);
    }
    updateScenarioNotes(locId: string, scenarioId: number, note: string): Observable<any> {

        let params = {
            locId: locId,
            scenarioId: scenarioId,
            note: note
        };

        return this.httpHelper.put(`${this._baseAirportUrl}/scenarionotes`, JSON.stringify(params));
    }

    updateAirport(airport: IAirport): Observable<any> {
        return this.httpHelper.put(`${this._baseAirportUrl}`, airport);
    }

    getAirportFromScenario(scenarioId: number): Observable<string> {
        return this.httpHelper.get(`${this._baseAirportUrl}/scenario-airport/${scenarioId}`);
    }

    getNextAndPreviousAirports(locId: string, scenarioId: number): Observable<any> {

        return this.httpHelper.get(`${this._baseAirportUrl}/next-previous/${scenarioId}/${locId}`);
    }

    getOperations(): Observable<IOperation[]>{
        return this.httpHelper.get(`${this._baseAirportUrl}/operations`);
    }

    getOperationsColumns(request: OperationsListRequest): Observable<IOperationListColumnResponse[]>{
        let url:string = `${this._baseAirportUrl}/operations-columns?` + 
                            `tableName=${request.tableName}` +
                            `&locId=${request.locId}` +
                            `&scenarioId=${request.scenarioId}` +
                            `&isAdmin=${request.isAdmin}`;
        return this.httpHelper.get(url);
    }

    getOperationsList(request: OperationsListRequest): Observable<any>{
        let url:string = `${this._baseAirportUrl}/operations-list?` + 
                            `tableName=${request.tableName}` +
                            `&locId=${request.locId}` +
                            `&scenarioId=${request.scenarioId}` +
                            `&isAdmin=${request.isAdmin}`;
        return this.httpHelper.get(url);
    }

    updateOperations(request: any): Observable<any>{
        return this.httpHelper.put(`${this._baseAirportUrl}/operations-update`, request);
    }

    saveOperationsYear(request: any): Observable<any>{
        return this.httpHelper.post(`${this._baseAirportUrl}/operations-year`, request);
    }
    
    getGraphMinYear(request: any): Observable<any>{
        let url:string = `${this._baseAirportUrl}/operations-graph/min-year?` + 
                            `tableName=${request.tableName}` +
                            `&locId=${request.locId}` +
                            `&scenarioId=${request.scenarioId}`;
        return this.httpHelper.get(url);
    }

    getGraphData(request: any): Observable<any>{
        return this.httpHelper.post(`${this._baseAirportUrl}/operations-graph`, request);
    }

    hasGraphData(request: any): Observable<any>{
        let url:string = `${this._baseAirportUrl}/operations-graph/has-data?` + 
                            `tableName=${request.tableName}` +
                            `&locId=${request.locId}` +
                            `&scenarioId=${request.scenarioId}`;
        return this.httpHelper.get(url);
    }

    getReforcastData(request: ReforecastRequest): Observable<IReforecastResponse []> {
        let url:string = `${this._baseAirportUrl}/operations-reforecast?` + 
                            `tableName=${request.tableName}` +
                            `&fieldName=${request.fieldName}` +
                            `&minYear=${request.minYear}` +
                            `&locId=${request.locId}` +
                            `&scenarioId=${request.scenarioId}`;
        return this.httpHelper.get(url);
    }

    reforecastSupplyData(request: any): Observable<any>{
        return this.httpHelper.post(`${this._baseAirportUrl}/operations-reforecast/supply-data`, request);
    }

    reforecastOperation(request: any): Observable<any>{
       return this.httpHelper.post(`${this._baseAirportUrl}/operations-reforecast/operation`, request);
    }

    getRegionalReview(scenarioId: number, userid: number): Observable<any>{
        return this.httpHelper.get(`${this._baseAirportUrl}/regionalreview/${scenarioId}/${userid}`);    
    }

    getRegionalReviewSummary(scenario: number): Observable<any>{
        let url:string = `${this._baseAirportUrl}/regionalreview-summary?Scenario=${scenario}`;
                            // `StartYear=${startYear}` +
                            // `&Scenario=${scenario}`;
        return this.httpHelper.get(url);
    }

    saveRegionalReview(request: any): Observable<any>{
        return this.httpHelper.postFile(`${this._baseAirportUrl}/regionalreview-update`, request);
    }

    deleteRegionalReviewFile(request: any): Observable<any>{
        return this.httpHelper.post(`${this._baseAirportUrl}/regionalreview-deletefile`, request);
    }

    submitRegionalReviewFile(request: any): Observable<any>{
        return this.httpHelper.post(`${this._baseAirportUrl}/regionalreview-submit`, request);
    }

    checkRegionalReviewFile(request: any): Observable<any>{
        return this.httpHelper.postFile(`${this._baseAirportUrl}/regionalreview-checkformat`, request);
    }
    
}



/** WEBPACK FOOTER **
 ** ./app/airports/airport.service.ts
 **/